import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9774c37a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-chart-group-name-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "New Profile Name:", -1))

import { ref, watch } from "vue";
import BaseInput from "@/ui-library/base-input/base-input.vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'change-chart-group-name-form',
  props: {
    modelValue: null,
    textAlign: null,
    tabIndexes: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  textAlign?: string;
  tabIndexes?: number[];
}





const newProfileName = ref(String(props.modelValue || ""));

function updateProfileName(value: string) {
  newProfileName.value = value;
  emit("update:modelValue", value);
}

watch(
  () => props.modelValue,
  (val) => {
    newProfileName.value = val;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseTypography, { subtitle3: "" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(BaseInput, {
      modelValue: newProfileName.value,
      "onUpdate:modelValue": updateProfileName,
      placeholder: "Enter new profile name",
      minLength: "1"
    }, null, 8, ["modelValue"])
  ]))
}
}

})